module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "المطار"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المطار")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صعدَ الجميع إلى الطّائرة ما عدا \"سيف\"؛ فقد تأخّر حتّى ظنَّ الجميع بأنَّه سيُفوِّت الرِّحلة. وعندَما حضرَ بادَرهُ هاشم قائلًا:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تأخَّرتَ حتّى ظننتُ أنّك لن تأتي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كان يجب أن أنهي كلَّ شيءٍ حتّى لا يبقى لها أملٌ في هذا الحبّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- \"ميثة\" انتبهت لوجودها، ليكن بمعلومك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أغلق عينيه وزفر:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أتمنّى منها ألّا تفتح الموضوع لأنّني لست بمزاجٍ يسمح لي بالجدال.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هي زوجتك، ومن حقّها أن تسألك، أنصحك بتجهيز قائمةِ إجاباتك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اترك الآن موضوعي على جنب وأخبرني عنك؛")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- عندما كنتُ بانتظارك كنتُ أستمتعُ بحوار الشّباب في الخلف، وقد لفتت انتباهي تحليلاتهم الدَّقيقة لِآخر مباراةٍ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظر إليهم سيف مبتسمًا:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ليس هذا هو القصد من سؤالي، لكن لا بأس!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فَهِمَ هاشم لكنَّه غيَّر الموضوع:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كانوا يتحدَّثون عن قرار دَمْج نادي العروبة ونادي الخليج!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسم سيف: نعم، قريبًا سيُولد كيانٌ جديد وباسْمٍ جديد!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- من ابتسامتك أفهم أنَّ قرارَ الدَّمج أفرحك، لماذا يا تُرى؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لأنّه سيحمل اسم إمارة الشّارقة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- آها، فهمتُ الآن سِرّ سعادتك بقرار الدّمج.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تخيَّل هذا الكيانَ الجديد سيحمل اسم أجمل وأغلى مدينةٍ على الإطلاق!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسم هاشم وقال: وأنا أرجو أن تقبلوا بي مُشجّعًا لنادي الشّارقة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقف ابن سيفٍ الأكبر \"رائد\" وتدخّل قائلًا:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- قبل أن نقبل بكَ يجب أن تفهمَ أنَّ جمهورنا ليس كأيِّ جمهورٍ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وبماذا تختلفون عن بقيَّة الجماهير يا رائد أفندي؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ عليه \"سلطان\" الابن الأوسط لسيف:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سأخبركَ أنا: كلُّ الأندية في العالم لديها مُشجِّعون؛")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- طبيعيّ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ما عدا نادينا، فقد خلق الله له عُشّاقًا أوفياء!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التفت هاشم ناحية سيف وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أورثتهم التّعصّب، وأظهرتَ في النّهاية أنّك حفيد رفعت الهاشم! لا بأسَ يا سلطان! أرجو أن تقبلوا بي عاشِقًا لناديكم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّ \"حمدُ\" الابن الأصغرُ على هاشم:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سنفكِّرُ بالأمر ونردّ عليك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّ هاشم باندهاشٍ على أسلوب حمد: أوف!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ليتدخّل سيفٌ قائلًا:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- دَعْكَ منهم الآن وأخبرْني عن أحوالِ قلبك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظر إلى الأمام وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يبدو أنَّ النَّصيب لا يعترفُ بأحكام الهوى، ولا يلتفتُ إلى مُعاناة العشّاقِ يا بن عمَّتي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لماذا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لأنّني لم أَلْتَقِ إلى الآن بعاشقٍ فاز بوَصْل محبوبته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سمعتُ بأنّكُما تصالحتُما؛ فماذا حصل لتفترقا من جديد؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تعرف يا سيف، بعدَ كلِّ تلك السّنوات اكتشفتُ أنّنا أعداءُ أنفسنا ولا أحد غيرنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ألا توضح؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- خيَّرَتْني بينها وبين عائلتي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تقصد بينَها وبين ثأرك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أَفْهَم كلَّ شيءٍ إلّا أنْ تغارَ عليَّ من امرأةٍ لم يَعدْ لها وجود في حياتي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- غيْرتُها دليلٌ على حبّها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتَ هاشمٌ، وراحَ سيفٌ ينظرُ من خلال النّافذة إلى الخارجِ، وعقلُه في مكانٍ آخر، وقد ظهر حُزنه بعد محاولاته إخفائِه عن هاشم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا جدوى من إخفاء حزنك يا سيف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كذبتُ عليك عندَما قلتُ بأنّني لم أعدْ أشعرُ بشيءٍ نحوها، فأنا ما زلتُ أتألم بسببها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وهذا الشّعور دليلٌ على أنَّك ما زلتَ تحبُّها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ما لا أَفْهمه يا هاشمُ، لماذا كلَّ هذا العناد؟! وكيف توقّعَتْ أنَّها سترجع وستجدني بانتظارها بعد الّذي حصل؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2cea7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 78
// module chunks = 0